import React, { useState, useEffect, useCallback } from "react";
import { Typography, Fade } from "@mui/material";

const QUOTES = [
  "You answered when someone needed help.",
  "Small actions. Big impact.",
  "Someone made it home because of you.",
  "Not all heroes wear badges, some carry jumper cables and that's bad ass.",
  "Another motorist helped. Another day made better.",
  "You showed up when it counted.",
  "No spotlight. Just service.",
  "Every mile you drove mattered.",
  "Quiet work. Real impact.",
  "Someone's worst moment met your best effort.",
  "You made the road safer today.",
  "What you do out here matters more than you know.",
  "A simple stop can mean everything.",
  "Service doesn't need recognition, but it deserves respect.",
  "You were the help they were hoping for.",
  "Head home knowing you helped someone today.",
  "You did good work out there.",
  "Rest easy. You earned it.",
  "Texas roads are better tonight because of you.",
];

const ROTATION_INTERVAL_MS = 60000; // 60 seconds
const FADE_DURATION_MS = 500;

/**
 * Displays rotating motivational quotes with fade animation.
 * Hidden when `hidden` prop is true (e.g., when announcement banner is active).
 */
export default function RotatingQuote({ hidden = false }) {
  const [currentIndex, setCurrentIndex] = useState(() => 
    Math.floor(Math.random() * QUOTES.length)
  );
  const [fadeIn, setFadeIn] = useState(true);

  const rotateQuote = useCallback(() => {
    // Fade out
    setFadeIn(false);
    
    // After fade out, change quote and fade in
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % QUOTES.length);
      setFadeIn(true);
    }, FADE_DURATION_MS);
  }, []);

  useEffect(() => {
    const interval = setInterval(rotateQuote, ROTATION_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [rotateQuote]);

  if (hidden) {
    return null;
  }

  return (
    <Fade in={fadeIn} timeout={FADE_DURATION_MS}>
      <Typography
        variant="body2"
        sx={{
          fontStyle: "italic",
          opacity: 0.8,
          ml: 2,
          display: { xs: "none", md: "inline" }, // Hide on small screens
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: { md: 300, lg: 450, xl: 600 },
        }}
      >
        <span style={{ fontStyle: "normal", marginRight: 8 }}>●</span>{QUOTES[currentIndex]}
      </Typography>
    </Fade>
  );
}
